export default __webpack_public_path__ + "static/media/comment-icon.0ece51ce.svg";